import { isIOS } from './lib/bridge'

const NavBar = () => (
    <div className="flex justify-between items-center p-8">
        <a href="/">
            <img
                src="https://cdn-sc-g.sharechat.com/33d5318_1c8/tools/32031d3d_1762842169404_sc.webp"
                alt="askk logo"
                className="w-60 h-16"
            />
        </a>
        {!isIOS && (
            <a
                href="https://play.google.com/store/apps/details?id=in.mohalla.askk"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block transition-transform hover:scale-105"
            >
                <img
                    src="https://cdn-sc-g.sharechat.com/33d5318_1c8/tools/32fda499_1762842169414_sc.webp"
                    alt="Get it on Google Play"
                    className="h-6 lg:h-10 w-auto rounded-2xl shadow-lg"
                />
            </a>
        )}

    </div>
)

export default NavBar